import { FormTemplate } from "components/modal/templates";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import React from "react";
import { apply } from "sources/books/counterpartyPoints";

const config = {
    geozone: {},
    counterpartyId: {
        label: "Контрагент",
        inputProps: { name: "counterpartyId" },
        required: true,
        validators: [requiredField],
    },
    name: {
        label: "Название",
        inputProps: { name: "name" },
    },
    client: {
        label: "Клиент",
        inputProps: { name: "client" },
    },
};
const initialState = getInitialStateFromConfig(config);

class CounterpartyPointForm extends FormTemplate {
    sendRequest = (stateData) => apply(stateData).then(this.props.successCallback);

    renderBodyInner = () => {
        const { name, counterpartyId, client } = this.props.config;
        return (
            <>
                <div className="row form-group field-wrap--value">
                    <label className="col-sm-4 col-md-3 col-form-label col-form-label-sm text-md-right text-sm-left">
                        Адрес
                    </label>
                    <div className="col-sm-8 col-md-9 col-form-label col-form-label-sm">
                        {this.props.geozone.address}
                    </div>
                </div>
                {this.props.counterpartyOptions.length !== 1 &&
                    this.renderSelect({ ...counterpartyId, options: this.props.counterpartyOptions })}
                {this.renderField(name)}
                {this.renderField(client)}
            </>
        );
    };

    renderActionSend = () => {
        const cname = "btn btn-brand btn-sm modal-window__footer-action";
        return <input type="submit" className={cname} value="Сохранить" />;
    };
}

const ConfiguredModal = (props) => {
    return (
        <CounterpartyPointForm
            {...props}
            config={config}
            initialState={{
                ...initialState,
                geozone: { ...props.geozone, id: undefined },
                counterpartyId: props.counterpartyOptions.length === 1 ? props.counterpartyOptions[0].value : undefined,
            }}
        />
    );
};

export default ConfiguredModal;
